/* eslint-disable no-console */
import React, { useEffect, useState, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { debounce } from 'lodash'
import Type from '../Components/Type'
import L from '../Components/L'
import CollectionGrid from '../Components/CollectionCard'
import { WEBSITE_CONFIG_COLLECTION, WEBSITE_CONFIG_ID, COLLECTIONS_COLLECTION, SIMULATIONS_COLLECTION } from '../Config'
import Layout from '../Components/Layout'
import LoginSSO from './LoginSSO'
import AccountActions from '../Redux/AccountRedux'

const DashboardPage = ({ match, ...props }) => {
  const firestore = useSelector(({ firestore }) => firestore)
  const { data, ordered } = firestore
  const config = data?.[WEBSITE_CONFIG_COLLECTION]?.[WEBSITE_CONFIG_ID]
  const collections = ordered?.[COLLECTIONS_COLLECTION] || []
  const simulations = data?.[SIMULATIONS_COLLECTION] || {}
  const firebase = useSelector(({ firebase }) => firebase)
  const { auth, authError, profile } = firebase
  const account = useSelector(({ account }) => account)
  const { claims } = account
  const dispatch = useDispatch()
  const [tabs, setTabs] = useState([{ link: '/', label: 'Dashboard' }])
  const [events, setEvents] = useState(false)
  const [verticals, setVerticals] = useState(false)

  const toggleSearch = isOpen => dispatch(AccountActions.AccountToggleSearch(isOpen))

  const createTabs = () => {
    const filteredArr = []
    if (collections) {
      Object.keys(collections).map(collectionKey => {
        const { type } = collections[collectionKey]
        if (!filteredArr.includes(type)) filteredArr.push(type)
      })
    }
    const tabsArr = [{ link: '/', label: 'Dashboard' }]
    if (filteredArr.includes('vertical')) {
      tabsArr.push({ link: '/verticals', label: 'Verticals' })
      setVerticals(true)
    }
    if (filteredArr.includes('event')) {
      tabsArr.push({ link: '/events', label: 'Events' })
      setEvents(true)
    }
    setTabs(tabsArr)
  }

  const debouncedCreateTabs = debounce(createTabs, 300)

  useEffect(() => {
    document.title = 'IdeaCloud | Dashboard'
    toggleSearch(false)
  }, [])

  useEffect(() => {
    debouncedCreateTabs()
  }, [collections])

  // BEGIN LOGIN LOGGING
  console.log('LOG authError', authError)
  if (!auth.isLoaded) console.log('LOG Dashboard: !auth.isLoaded')
  if (!profile.isLoaded) console.log('LOG Dashboard: !profile.isLoaded')
  if (claims === null) console.log('LOG Dashboard: claims === null')
  if (!config) console.log('LOG Dashboard: !config', config)
  // END LOGIN LOGGING

  if (!auth.isLoaded || !profile.isLoaded || claims === null || !config) return null

  // BEGIN LOGIN LOGGING
  if (auth.isEmpty) console.log('LOG Dashboard: auth.isEmpty - showing Login Component')
  // END LOGIN LOGGING

  if (auth.isEmpty) return <LoginSSO />

  return (
    <Layout title="Home" hide full backgroundColor="#F9F9FB" tabs={tabs} tab={match?.path}>
      <L container display="grid" gap={5} pY={3}>
        {props.children && props.children}
        {!props.children && (
          <>
            {verticals && (
              <L display="grid" gap={3}>
                <L display="grid" flow="column" ai="center" jc="space-between" gap={2}>
                  <Link to="/verticals">
                    <Type variant="titleLarge">Verticals</Type>
                  </Link>
                </L>
                <CollectionGrid
                  collections={collections}
                  simulations={simulations}
                  type="vertical"
                  baseUrl="/verticals#"
                />
              </L>
            )}
            {events && (
              <L display="grid" gap={3}>
                <Link to="/events">
                  <Type variant="titleLarge">Events</Type>
                </Link>
                <CollectionGrid collections={collections} simulations={simulations} type="event" baseUrl="/events#" />
              </L>
            )}
          </>
        )}
      </L>
    </Layout>
  )
}

export default memo(DashboardPage)
